import { SEP_FIND_URL } from "../../lib/constants";

type Props = {
  sepGatewayLink?: string;
};

export default function WeveMoved({ sepGatewayLink }: Props) {
  return (
    <div className="my-4 rounded-xs shadow p-6 text-center max-w-[1000px] mx-auto bg-gray-100">
      <img
        src="/sep-logo.png"
        alt="Sports Engine Play Logo"
        width={300}
        height={100}
        className="mx-auto mb-4"
      />
      <h2 className="text-2xl font-semibold mb-2 se-title-text">
        We've moved to a new streaming service!
      </h2>
      <p className="text-sm mb-4">
        Same exciting content, FREE of cost, plus many new benefits!{" "}
        <a
          className="se-link-text underline"
          href={sepGatewayLink || SEP_FIND_URL}
        >
          Check it out now.
        </a>
      </p>
    </div>
  );
}
